import { whenTrue } from '@woorcs/utils'

export const isFocused = whenTrue(['focused'])
export const isDisabled = whenTrue(['disabled'])
export const isInvalid = whenTrue(['invalid'])
export const isInvalidAndDisabled = whenTrue(['invalid', 'error'])
